// extracted by mini-css-extract-plugin
export default {"fullWidth":"Xl-z","image":"Yl-z","lazyLoadPicture":"Zl-z","lazyLoadSpinner":"_l-z","lazyLoadSpin":"am-z","lazyLoadImage":"bm-z","hasStyledAspectRatio":"cm-z"};